module.exports = __webpack_public_path__ + "img/outofspace-small.6de9ea8d.jpg";